// 禁止复制
let banCopy = function(){
    console.log('调用禁止复制事件')
    // oncontextmenu事件禁用右键菜单；
    document.oncontextmenu = function(){
        return false;
    }
    // onselectstart事件禁用网页上选取的内容；
    document.onselectstart = function(){ 
        return false; 
    }
    // oncopy事件禁用复制；
    document.oncopy = function(){ 
        return false; 
    }
}
//恢复操作
let recoverCopy = function(){
    console.log('调用恢复操作事件')
    document.oncontextmenu = function(){
        return true;
    }
    document.onselectstart = function(){ 
        return true; 
    }
    document.oncopy = function(){ 
        return true; 
    }
}



export default {
    banCopy,
    recoverCopy
}